import service from '@/plugin/axios/public'

// 埋点请求接口
const PostEvent = (data = {}) => service({
  url: '/public/common/event/tracking',
  method: 'post',
  data
})

const PAGE_ID = {
  main: 1,    // 上线年检推广页主页面
}

const EVENT_ID = {
  view: 1,      // 访问
  appointed: 2, // 预约成功
  shared: 3,    // 微信分享
}

/**
 * 把高德地图返回的citycode(4位)和系统的citycode(6位)不适用
 * 所以使用高德返回的adcode, 然后转为系统适用的citycode
 * @param {String} adcode 
 * @returns {String} 系统适用的citycode
 */
export function cityCodeAdapter(adcode) {
  return adcode ? `${adcode.slice(0, 4)}00` : ''
}

/**
 * 埋点辅助类
 */
class EventTracking {
  constructor() {
    this.citycode = ''    // 城市编码
    this.companyId = ''   // 渠道商id
  }

  /**
   * 进入页面
   * @param {String|Number} pageId - 页面id
   */
  enter(pageId = PAGE_ID.main) {
    const params = this.getParams({
      pageId,
      eventId: EVENT_ID.view
    })
    PostEvent(params).catch(err => console.error(err))
  }

  /**
   * 预约成功
   */
  appointed(pageId = PAGE_ID.main) {
    const params = this.getParams({
      pageId,
      eventId: EVENT_ID.appointed
    })
    PostEvent(params).catch(err => console.error(err))
  }

  /**
   * 微信分享给朋友
   */
  shareAppMessage(pageId = PAGE_ID.main) {
    const params = this.getParams({
      pageId,
      eventId: EVENT_ID.shared
    })
    PostEvent(params).catch(err => console.error(err))
  }

  /**
   * 微信分享朋友圈
   */
  shareTimeline(pageId = PAGE_ID.main) {
    const params = this.getParams({
      pageId,
      eventId: EVENT_ID.shared
    })
    PostEvent(params).catch(err => console.error(err))
  }

  getParams({ pageId, eventId }) {
    if (!this.citycode || !this.companyId) {
      throw new TypeError('EventTracking: 无效的 citycode 或 comanyId')
    }
    return {
      pageId,
      eventId,
      channelCompanyId: this.companyId,
      cityCode: this.citycode,
      operateTime: Date.now()
    }
  }

  /**
   * 设置citycode
   * 需要设置citycode的节点：
   *  1. 初进页面定位完成时
   *  2. 选择地址切换城市时
   * @param {String} adcode - 高德地图返回的adcode
   */
  setCityCode(adcode) {
    this.citycode = cityCodeAdapter(adcode)
  }

  /**
   * 设置渠道商id
   */
  setCompanyId(id) {
    this.companyId = id
  }
}

export const eventTrackHelper = new EventTracking()
